module.exports = __webpack_public_path__ + "static/img/school-3.46aadaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/school-3.png
// module id = lUE7
// module chunks = 1